import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';
import AtivosForm from './AtivosForm';
import AtivosRow from './AtivosRow';

class Ativos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ativos: [],
            ativo: { id: '', nome: '', tipo: 'ACAO', api_id: '' },
        };
    }

    componentDidMount = () => {
        this.atualizarAtivos();
    }

    atualizarAtivos = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/ativos`);
            this.setState({ ativos: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChangeNome = (evt) => {
        let ativo = {...this.state.ativo};
        ativo.nome = evt.target.value;
        this.setState({ ativo });
    }

    handleChangeTipo = (evt) => {
        let ativo = {...this.state.ativo};
        ativo.tipo = evt.target.value;
        this.setState({ ativo });
    }

    handleChangeApi = (evt) => {
        let ativo = {...this.state.ativo};
        ativo.api_id = evt.target.value;
        this.setState({ ativo });
    }

    handleSave = async () => {
        try {
            const ativoToSave = Object.assign({}, this.state.ativo);
            delete ativoToSave.id;
            if(this.state.ativo.id) {
                await axios.put(`${ambiente.dev.server}/ativos/${this.state.ativo.id}`, {...ativoToSave});
                this.props.exibirMensagem('yay', 'Ativo atualizado com sucesso!');
            } else {
                await axios.post(`${ambiente.dev.server}/ativos`, {...ativoToSave});
                this.props.exibirMensagem('yay', 'Ativo inserido com sucesso!');
            }
            this.setState({ ativo: { id: '', nome: '', tipo: '', api_id: '' } });
            this.atualizarAtivos();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleDelete = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/ativos/${id}`);
            this.atualizarAtivos();
            this.props.exibirMensagem('yay', 'Ativo excluído com sucesso!');
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <div>
                <h2>Ativos</h2>
                <AtivosForm ativo={this.state.ativo} handleChangeNome={this.handleChangeNome} handleSave={this.handleSave}
                    handleChangeTipo={this.handleChangeTipo} handleChangeApi={this.handleChangeApi}  />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Ativo</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.ativos && 
                            this.state.ativos.map(item => 
                                <AtivosRow key={item.id} ativo={item}
                                    handleDelete={this.handleDelete}
                                    handleUpdate={ativo => this.setState({ ativo })} />) }
                    </tbody>
                </table>
            </div>
        );
    }
}

Ativos.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Ativos);
  


// WEBPACK FOOTER //
// ./src/components/ativos/Ativos.js